<template>
  <row :gutter="48" class="sc-scenario-select">
    <i-col span="14">
      <div class="ms-help label">
        Сценарий расчета стоимости
      </div>
      <i-select
        size="default"
        v-model="contract[`${type}_scenario`]"
        placeholder="Выберите сценарий"
        @on-change="scenarioChangeHandler"
      >
        <i-option
          v-for="item in scenarios"
          :value="item.value"
          :key="item.value"
        >
          {{ item.name }}
        </i-option>
      </i-select>
    </i-col>
    <i-col span="10">
      <div class="ms-help label">
        Принцип указания даты
      </div>
      <i-select
        size="default"
        v-model="contract[`${type}_date_type`]"
        placeholder="Выберите принцип"
        @on-change="dateTypeChangeHandler"
      >
        <i-option
          v-for="item in dateTypes"
          :value="item.value"
          :key="item.value"
        >
          {{ item.name }}
        </i-option>
      </i-select>
    </i-col>
  </row>
</template>

<script>
const scenarios = [
  { value: 1, name: 'Абсолютная сумма на все этапы' },
  { value: 2, name: 'Процент от стоимости на все этапы' },
  { value: 3, name: 'Процент от стоимости на несколько этапов' }
]
const dateTypes = [
  { value: 1, name: 'Количество дней' },
  { value: 2, name: 'Точная дата' }
]

export default {
  props: ['type', 'contract'],
  data () {
    return {
      scenarios,
      dateTypes
    }
  },
  computed: {
    contractCosts () {
      const otherType = this.type === 'prepaid' ? 'retention' : 'prepaid'
      const sum = this.contract.roadmaps.reduce((prev, r) => prev + r.costs, 0)
      const result = sum - this.contract[`${otherType}_amount`]

      return result
    }
  },
  methods: {
    scenarioChangeHandler (value) {
      if (value !== 1) {
        const costs = this.contract.roadmaps.reduce((prev, el) => prev + el.costs, 0)
        const percentage = this.contract[`${this.type}_percentage`]

        this.contract[`${this.type}_amount`] =
          Math.floor((costs * percentage) / 100)
      }

      if (value === 3) {
        this.contract.roadmaps.forEach(r => {
          this.$set(r, `${this.type}_value`, 0)
        })
      }
    },
    dateTypeChangeHandler (value) {
      switch (value) {
        case 1:
          this.contract[`${this.type}_condition_date`] = null
          break
        case 2:
          this.contract[`${this.type}_condition`] = 0
          break
      }
    }
  }
}
</script>

<style>
</style>
